module.exports = __webpack_public_path__ + "static/img/scene12.acfe36e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/scene12.jpg
// module id = o9DE
// module chunks = 1